import { render, staticRenderFns } from "./complaints.pug?vue&type=template&id=2657651c&lang=pug&external"
import script from "./complaints.js?vue&type=script&lang=js&external"
export * from "./complaints.js?vue&type=script&lang=js&external"
import style0 from "./complaints.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "@ui-common/vue-progress/dist/vue-progress.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "./complaints-placeholder.scss?vue&type=style&index=2&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports